module.exports = __webpack_public_path__ + "img/Group 850.fb388e58.png";